// extracted by mini-css-extract-plugin
export default {"ImgModal":"ImgModal_ImgModal__Vx4qJ"};